module.exports = "<app-notificacions></app-notificacions>"